var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hot-dropdown-menu-item',{class:_vm.itemClass,attrs:{"slot":"menu","name":_vm.name},on:{"click":_vm.select},slot:"menu"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }